import { render, staticRenderFns } from "./features-nav.vue?vue&type=template&id=63acf149"
import script from "./features-nav.vue?vue&type=script&lang=js"
export * from "./features-nav.vue?vue&type=script&lang=js"
import style0 from "./features-nav.vue?vue&type=style&index=0&id=63acf149&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports